import React from 'react';
import { useSelector } from 'react-redux';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import lineupReducer from '../store/reducers/lineup';
import lineupDataRequestAction from '../store/actions/lineupDataRequestAction';
import homeLineupDataSource from '@gameday/core/datasources/homelineup';
import awayLineupDataSource from '@gameday/core/datasources/awaylineup';
import scheduleDataSource from '@gameday/core/datasources/schedule';
import { getLineupMatchupState } from '../store/selectors/getLineupMatchup';
import Lineup from '../components/Lineup';
import  { StyledCard, DesktopWrapper} from '../LineupMatchup.style';
import { useMedia } from '@mlb/react-patterns/v4/utils/hooks/useMedia/useMedia';
import { GDBREAKPOINTS_NUM } from '@gameday/components/themes/breakpoints';

const fetchData = () => {
    return lineupDataRequestAction();
};

initContainerData.register({
    datasources: {
        awaylineup: awayLineupDataSource,
        homelineup: homeLineupDataSource,
        schedule: scheduleDataSource
    },
    reducers: {
        previewlineup: lineupReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const LineupDataContainer = () => {
    const isMobile = useMedia({ maxWidth: `${GDBREAKPOINTS_NUM.MD -1}px`});

    const {
        awaylineup = {},
        homelineup = {}
    } = useSelector(getLineupMatchupState);

    const awayData = awaylineup?.data || {};
    const awayError = awaylineup?.error;
    const awayHasLineup = awaylineup?.hasLineup;

    const homeData = homelineup?.data || {};
    const homeError = homelineup?.error;
    const homeHasLineup = homelineup?.hasLineup;

    return (
        <>
            { isMobile ? <StyledCard>
                <Lineup data={awayData} error={awayError} hasLineup={awayHasLineup} />
                <Lineup data={homeData} error={homeError} hasLineup={homeHasLineup} />
            </StyledCard> : <DesktopWrapper>
                <StyledCard><Lineup data={awayData} error={awayError} hasLineup={awayHasLineup} /></StyledCard>
                <StyledCard><Lineup data={homeData} error={homeError} hasLineup={homeHasLineup} /></StyledCard>
            </DesktopWrapper> }
        </>
    );
};

LineupDataContainer.propTypes = {

};

export default LineupDataContainer;
export { fetchData, routes };
